// vamos importar nesse arquivo tudo que precisa ser utilizado no projeto. Seja JS ou CSS
import 'animate.css/animate.min.css'
import './main.css';
import presencial from "./pfunctions.js";

global.novoPresencial = new presencial();

$(function(){

  $('#Botao').on('click', function(){
    if($(this).hasClass('is-btn-type-off')) { 
      window.open("../login_site.asp", "_self");
    } else {
      novoPresencial.Fazerlance();
    }
  });

  $('.is-minifooter').on('click', function(){
    $(this).toggleClass('is-open');
    $('footer').toggleClass('is-closed');
  });

  $('.is-trigger').on('click', function(){
    window.open("../login_site.asp", "_self");
  });

   //só mostra tooltip se não for mobile
  function defineTooltip() {
    if(!novoPresencial.ismobile()){
      $('[data-toggle="tooltip"]').tooltip()
    }
  }
  defineTooltip();
  
  function defineInteract() {
    if(novoPresencial.ismobile()){
      interact('.is-lances-list').resizable({
        edges: { top: '.is-lances-title', left:false, right:false, bottom:false },
        listeners: {
          move: function (event) {
            let { x, y } = event.target.dataset
  
            x = (parseFloat(x) || 0) + event.deltaRect.left
            y = (parseFloat(y) || 0) + event.deltaRect.top
  
            Object.assign(event.target.style, {
              width: `${event.rect.width}px`,
              height: `${event.rect.height}px`,
            })
  
            Object.assign(event.target.dataset, { x, y })
          }
        },
        modifiers: [  
          // minimum size
          interact.modifiers.restrictSize({
            min: { height: 40 }
          })
        ],
      });
    }
  }

  defineInteract();


  $('.left-section').on('scroll', function() {
    if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
      //$('.is-scrollalert').css('opacity','0');
      $('.is-scrollalert').addClass('atBottom');
    } else if($(this).innerHeight() >= (($('.is-lote-intro').height()) + ($('.is-lote-content').height()))){
      $('.is-scrollalert').removeClass('atBottom');
    } else {
      $('.is-scrollalert').removeClass('atBottom');
      //$('.is-scrollalert').css('opacity','1');
    }
  });

  $(document.body).on('click', '.is-iframe-controls a', function() {
    var liclass = $(this).parent('li').attr("id");
    var iframeWrap = $('.iframe-wrap');
    switch(liclass){
      case "is-diminuir-frame":
        iframeWrap.addClass("is-short");
        break;
      case "is-aumentar-frame":
        iframeWrap.removeClass("is-short");
        break; 
      case "is-fechar-frame":
        iframeWrap.addClass("is-closed");
        iframeWrap.removeClass("is-short");
        iframeWrap.find('iframe').remove();
        break;    
      case "is-abrir-frame":
        iframeWrap.removeClass("is-closed");
        iframeWrap.removeClass("is-short");
        iframeWrap.append(novoPresencial.stringvideo);
        break;   
    }
  });

  $(document.body).on('click', '.has-popover', function() {
    var options = {
      html:true,
      container: 'body',
      trigger: 'click',
      placement: 'right',
      template: novoPresencial.proxlotePop_template,
      boundary: 'viewport',
      offset: "5vh"
    };

    if(!novoPresencial.ismobile()){
      options.placement = "right";
    }

    // todos os itens que terão popover
    $(this).popover(options).on('show.bs.popover',function(e){
      $(".has-popover").not(e.target).popover("dispose");
      $(".popover").remove(); 
    });
    $(this).popover('show');
  });

  $('.is-desc-popover').on('click', function(){
  //$(document.body).on('click', '.is-desc-popover', function() {
    // todos os itens que terão popover
    $(this).popover({
      html:true,
      container: 'body',
      trigger: 'click',
      placement: 'top',
      template: novoPresencial.proxlotePop_template,
      boundary: 'viewport',
    });
    $(this).popover('show');
  });

  $('.is-openclose-lances').on('click', function(){
    // todos os itens que terão popover
    novoPresencial.openCloseLances();
  });

  $('.is-proxlotes-display').on('click',function(){  
    // todos os itens que terão popover
    $('footer').toggleClass('is-open');
    $(this).toggleClass('is-open');
    $(".has-popover").popover("dispose");
    $(".popover").remove(); 
  });

  $(document.body).on('click', '.popover-close', function(){
    var parentPop = $(this).parent();
    var id = parentPop.attr('id');
    var pelement = $('[data-id='+id+']');
    parentPop.popover('hide');
    pelement.removeAttr('data-id');
    pelement.removeClass('open');
  });

  $('.main-img').on('mouseenter',function(){  
    if(!novoPresencial.ismobile()){
      var selimg = $(this)[0];
      window.productZoom = new Drift(selimg, {
        inlinePane: true,
        zoomFactor: 2,
      });
    }
  });

  $('.main-img').on('mouseleave',function(){ 
    if(!novoPresencial.ismobile()){
      window.productZoom.destroy(); 
    }
  });

  $(document.body).on('click', '.is-lotethumb-wrap', function(){
    var clickedthumb = $(this);
    var imagelink = clickedthumb.find('img').attr('src');
    var imagelink2 = clickedthumb.find('img').data('original');
    var bigimg = $('.is-loteimg-box').find('img');
    bigimg.attr('src', imagelink);
    bigimg.attr('data-zoom', imagelink2);

    $('.is-lotethumb-wrap').each(function(){
      $(this).removeClass('active');
    });
    clickedthumb.addClass('active');
  });

  $('.is-btnscroll').on('click',function(){ 
    var clicked = $(this);
    var scrollside = clicked.data('orientation');
    var target = clicked.data('target');
    switch(scrollside){
      case "left":
        novoPresencial.scrollLft(target);
        break;
      case "right":
        novoPresencial.scrollRight(target);
        break; 
      case "top":
        novoPresencial.scrollUp(target);
        break;    
      case "bottom":
        novoPresencial.scrollBottom(target);
        break;   
    }
  });

  $(document.body).on('click', '.alerta-icon', function(){
    $('.modal').modal('show');
    //novoPresencial.criaModal('Mensagem salão',  novoPresencial.mensagens.mensagem_salao);
  });

  $('.is-desc-scrl').on('click',function(){ 
    var clicked = $(this);
    var target = clicked.data('target');
    novoPresencial.scrollToBottom(target);
  });

  $('.is-scrollalert a').on('click',function(){ 
    var clicked = $(this);
    var target = clicked.data('target');
    if(clicked.parent().hasClass("atBottom")){
      novoPresencial.scrollToTop(target);
    } else {
      novoPresencial.scrollBottom(target);
    } 
  });

  $('.is-whatsapp a').on('click', function(e){
    e.preventDefault();
    var whatslink = "https://api.whatsapp.com/send?phone=55"+novoPresencial.whatsappNum+"&text="+novoPresencial.whatsappMsg+" "+novoPresencial.loteatual+" Link: "+novoPresencial.urlsite+"peca.asp?ID%3d"+novoPresencial.pecaatual+"";
    window.open(whatslink, '_blank');
  });

});  